import React from "react";
import Modal from "./Modal";
import PDFPreview from "./PDFPreview";

const ModalPDFPreview = ({ onClose, document }) => {
    return (
        <Modal show closeOnEscape onClose={onClose} size="60%" bodyStyle={{ alignSelf: 'stretch', marginTop: 0 }}>
            <PDFPreview document={document} />
        </Modal>
    );
};

export default ModalPDFPreview;
